<script lang="ts" setup>
import { ParagraphIframe } from '~/api/graphql/generated'

defineProps<{
  entity: ParagraphIframe
}>()
</script>

<template>
  <Section>
    <div class="t-10 t-o-1 tl-7 tl-o-0 ds-o-1">
      <iframe
        v-if="entity.fieldIframe"
        :src="entity.fieldIframe.url ?? ''"
        :title="entity.fieldIframe.title ?? ''"
        :width="entity.fieldIframe.width ?? '100%'"
        :height="entity.fieldIframe.height ?? 'auto'"
        frameborder="0"
        marginheight="0"
        allow="fullscreen"
      />
    </div>
  </Section>
</template>
